/* eslint-disable eqeqeq */
import { ROULETTE_IDS, LUCKY7_ID, THIRTY_TWO_CARDS_ID } from '@ezugi/constants';

export const getMinMaxLimits = ({ gameId, limits = {} }) => {
  try {
    if (limits.Denomination) {
      return {
        id: limits.id,
        min: limits.Denomination,
        max: limits.Denomination,
        denomination: limits.Denomination,
      };
    }
    if (gameId == LUCKY7_ID) {
      const minLimits = [
        limits.Min_Group1,
        limits.Min_Bet,
        limits.Min_Group2,
      ].filter(Boolean);

      const maxLimits = [
        limits.Max_Group1,
        limits.Max_Bet,
        limits.Max_Group2,
      ].filter(Boolean);

      return {
        id: limits.id,
        min: Math.min(...minLimits),
        max: Math.max(...maxLimits),
      };
    }
    if (gameId == THIRTY_TWO_CARDS_ID) {
      const minLimits = [
        limits.Min_Group8,
        limits.Min_Group9,
        limits.Min_Group10,
        limits.Min_Group11,
        limits.Min_Bet,
      ].filter(Boolean);

      const maxLimits = [
        limits.Max_Group8,
        limits.Max_Group9,
        limits.Max_Group10,
        limits.Max_Group11,
        limits.Max_Bet,
      ].filter(Boolean);

      return {
        id: limits.id,
        min: Math.min(...minLimits) || 0,
        max: Math.max(...maxLimits) || 0,
      };
    }
    if (ROULETTE_IDS.includes(gameId)) {
      const minLimits = [
        limits.Min_StraightUpBet,
        limits.Min_SplitBet,
        limits.Min_StreetBet,
        limits.Min_CornerBet,
        limits.Min_LineBet,
        limits.Min_Dozen_ColumnBet,
        limits.Min_OutsideBet,
        limits.Min_Bet,
      ].filter(Boolean);

      const maxLimits = [
        limits.Max_StraightUpBet,
        limits.Max_SplitBet,
        limits.Max_StreetBet,
        limits.Max_CornerBet,
        limits.Max_LineBet,
        limits.Max_Dozen_ColumnBet,
        limits.Max_OutsideBet,
        limits.Max_Bet,
      ].filter(Boolean);

      return {
        id: limits.id,
        min: Math.min(...minLimits) || 0,
        max: Math.max(...maxLimits) || 0,
      };
    }
  } catch (_error) {}

  return {
    id: limits.id,
    min: limits.Min_Bet || 0,
    max: limits.Max_Bet || 0,
  };
};

export function isSplitSeat(id) {
  return id.indexOf('-2') !== -1;
}
